import styled from 'styled-components';

export const RegisterFormComponentContainer = styled.div`
    .register-form {
        margin: 0 auto;

        .form-submit-container {
            text-align: center;
            margin: 20px 0;
            .bt {
                width: 100%;
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/authentication/register/RegisterFormComponentStyle.js